import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import WhyUsCard from "./WhyUsCard";
import {
  whyUsCard1,
  whyUsCard2,
  whyUsCard3,
  whyUsCard4,
} from "../../../assets";
import { useMediaQuery } from "react-responsive";
import { Carousel } from "antd";
import { getStrapiMedia } from "../../../helpers/tranformers";

const WhyUs = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div className="why-us-bg">
      <div className="section-content mobile-padding-all">
        <div
          className="about-section-heading "
          data-aos="fade-right"
          data-aos-duration="700"
          // style={isMobile ? {textAlign:"center"}:{}}
        >
          {content?.Heading}{" "}
        </div>
        <div
          className="section-heading"
          data-aos="fade-right"
          data-aos-duration="700"
          // style={isMobile ? {textAlign:"center"}:{}}
        >
          {content?.Title}
        </div>

        {!isMobile ? (
          <div
            className="card-section"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            {content?.Card?.map((card, index) => {
              return (
                <WhyUsCard
                  title={card?.Title}
                  desc={card?.Description}
                  iconimg={getStrapiMedia(card?.Image?.url)}
                  key={index}
                />
              );
            })}
          </div>
        ) : (
          <div className="card-section">
            <Swiper
              slidesPerView={1}
              spaceBetween={20}
              loop={true}
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              modules={[Pagination]}
              style={{
                width: "100%",
                height: "100%",
                padding: "0 10px 30px",
              }}
              className="mySwiper"
            >
              {content?.Card?.map((card, index) => {
                return (
                  <SwiperSlide className="why-us-slide" key={index}>
                    {" "}
                    <WhyUsCard
                      title={card?.Title}
                      desc={card?.Description}
                      iconimg={getStrapiMedia(card?.Image?.url)}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        )}
      </div>
    </div>
  );
};
export default WhyUs;
